import * as util from '@static/js/util.js';
import store from "../store";
import {previewData} from '@pageRouter/bean/previewData.js'
const defaultImg = '@static/images/timg.jpg';

const install = function (Vue, options) {

  Vue.prototype.getHashCode = function (str, caseSensitive) {
    if (!caseSensitive) {
      str = str.toLowerCase();
    }
    var hash = 1315423911, i, ch;
    for (i = str.length - 1; i >= 0; i--) {
      ch = str.charCodeAt(i);
      hash ^= ((hash << 5) + ch + (hash >> 2));
    }
    return (hash & 0x7FFFFFFF);
  };

  Vue.prototype.getImgPreview = function (url, width) {
    let fileType = util.getFileType(url);
    if ('pic' == fileType) {
      if (!width) {
        width = 320;//默认320

      }
      if (url.indexOf('/v1') !== -1) {
        url = url.replace('/v1', '')
      }
      return url + '@' + width + 'w_2000h_75Q';
    }
    if (!url) {
      return '';
    }
    var previewKey = Vue.prototype.getPreviewKey();
    if (!previewKey) {
      return url;
    }
    url = url.replace('file.uclass.ruijie.com.cn', 'img.uclass.ruijie.com.cn').replace('smartclass.oss-cn-hangzhou.aliyuncs.com', 'img.uclass.ruijie.com.cn');
    return 'http://ow365.cn/?i=' + previewKey + '&info=1&furl=' + url;
  };

  Vue.prototype.getFilePreview = function (url) {
    let fileType = util.getFileType(url);
    if ('pic' == fileType || 'video' == fileType || 'audio' == fileType || 'link' == fileType) {
      return url;
    }
    if (!url) {
      return '';
    }
    var previewKey = Vue.prototype.getPreviewKey();
    if (!previewKey) {
      return url;
    }
    url = url.replace('file.uclass.ruijie.com.cn', 'img.uclass.ruijie.com.cn').replace('smartclass.oss-cn-hangzhou.aliyuncs.com', 'img.uclass.ruijie.com.cn');
    return 'http://ow365.cn/?i=' + previewKey + '&furl=' + url;
  };


  Vue.prototype.imgerr = function (event) {
    var target = event.target;
    var src = target.src;
    if (src.indexOf('@') > -1) {
      src = src.split('@')[0];
    }

    if (util.getFileType(src) == 'pic') {
      $(target).attr('data-src', defaultImg);
      target.src = defaultImg;
    }
  }

  // 资源预览
  Vue.prototype.previewResView = function (context, item, classId) {
    if (item.type === 31) { // 为31则为url
      //修改为内部嵌入
      //window.location.href = item.saveNameStr
	  context.$bus.$emit('startPreviewUrl', previewData(item.id,classId,item.onlinePreviewAddress,item.saveNameStr,item.saveNameStr))
      return
    }
    // let type = util.getFileType(item.saveName)
    // if (type === 'pic') { // 图片不用预览
    //   return
    // }

    if (item.transStatus === 0) { // 转码中， 1为转码成功
      weui.alert('<p>正在转码</p> <p>请稍后预览</p>')
      return
    }
    if (item.transStatus === 2) { // 转码失败
      let tip = '<p>转码失败,无法预览</p><p>请联系老师处理</p>'
      if (item.isStudent) {
        tip = '<p>转码失败,无法预览</p><p>请自行检查,重新上传</p>'
      }
      weui.alert(tip)
      return
    }
    if (!item || this.utils.isEmpty(item.onlinePreviewAddress)) {
      return weui.alert('预览文件不存在')
    }
    console.log(item.onlinePreviewAddress)

    context.$bus.$emit('startPreview', previewData(item.id,classId,item.onlinePreviewAddress,item.saveNameStr))
  }

  // export const insertKeyupDorm = function (el, binding, vNode) {
  // 	el.addEventListener('keyup', function(event) {
  // 		// 首先去除已有样式
  // 		el.className = el.className.replace('input-error', '').trim()
  // 		if (!event.keyCode) { // 加上这个判断就是在提交时，才会校验
  // 			// 判断是否是否必填
  // 			let isRequired = binding.value.required;
  // 			let msg = binding.value.msg;
  // 			if (isRequired) {
  // 				if (!el.value || el.value === '') {
  // 					weui.alert(msg + '不能为空');
  // 					el.className += ' input-error';
  // 				}
  // 			}
  // 		}
  // 	})
  // };
  //
  // export const inserClickupDorm = function(el, binding, vNode) {
  // 	el.addEventListener('click', function (event) {
  // 		let elements = document.getElementsByClassName('v-check')
  // 		var evObj = document.createEvent('Event')
  // 		evObj.initEvent('keyup', true, true)
  // 		for (let element of elements) {
  // 			element.dispatchEvent(evObj);
  // 			if (!element.value || element.value === '') {
  // 				//   weui.alert(msg+'不能为空');
  // 				element.className += ' input-error';
  // 			}
  // 		}
  // 		let errorInputs = document.getElementsByClassName('input-error');
  // 		if (errorInputs.length === 0) {
  // 			vNode.context.save();
  // 		} else {
  // 			event.stopPropagation();
  // 			return;
  // 		}
  // 	});
  // }
}

export default install









// WEBPACK FOOTER //
// ./src/utils/baseFunction.js